import ModalOutcomesEventHistory from "./ModalOutcomesEventHistory";

export default ModalOutcomesEventHistory;